import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { DataService } from '../../services/DataService';
import { UntypedFormBuilder, UntypedFormGroup,Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
@Component({
    selector: 'app-text-summarizer',
    templateUrl: './text-summarizer.component.html',
    styleUrls: ['./text-summarizer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextSummarizerComponent implements OnInit {
  form: UntypedFormGroup;
  private storage: any;
  public ELEMENT_DATA:{}[];
  summarizedText:string='';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns:string[]=[];
  ShowLoader :string = "none";
  public dataSource:MatTableDataSource<{}>;
  file:File;

  constructor(private api:DataService,      
    public fb: UntypedFormBuilder,
    private app: AppComponent ) {this.storage = sessionStorage;
      this.form = this.fb.group({
    
    summarize_text:['',Validators.required],
    summarize_text_file: [null,Validators.required],
    FileSearch:[false]
  })}

  ngOnInit(): void {
  }

  goBack(){
    this.app.ShowDiv('TextAnalysis');
  } 

  submitForm(){
    this.ShowLoader='block';
    let auth_token = this.storage["msal.idtoken"];
    var formData: any = new FormData();
    if(this.form.get('FileSearch')?.value){
      formData.append("summarize_text_file",  this.file);
    }
    else{
      formData.append("summarize_text", this.form.get('summarize_text')?.value);
    }
    this.api.TextSummarizeData(auth_token,formData).subscribe((result:any) => {
      console.log(result);
      if(this.form.get('FileSearch')?.value){
      this.ELEMENT_DATA=result.SummarizedText;
      this.displayedColumns=Object.keys(this.ELEMENT_DATA[0]);
      this.dataSource= new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      }
      else{
        this.summarizedText=result.SummarizedText[0].summarizedText;
      }
      
      this.ShowLoader='none';
     
    },
    (error) => console.log(error))

  }

  uploadFile(event:any) {
    //debugger;
    let extensionAllowed:any = {"csv":true};
    console.log(event.target.files);
    if (event.target.files[0].size / 1024 / 1024 > 2) {
      alert("File size should be less than 2MB")
      return;
    }
    if (extensionAllowed) {
      var nam = event.target.files[0].name.split('.').pop();
      if (!extensionAllowed[nam]) {
        alert("Please upload " + Object.keys(extensionAllowed) + " file.")
        return;
      }
    }
    //this.form.controls["job_profile_match_file"].setValue(event.target.files[0]);
    this.file = event.target.files[0];
      // const file:File = (event.target as HTMLInputElement).files[0];
    
    // this.form.patchValue({
    //   job_profile_match_file: file
    // });
    
    // if(this.form.get('job_profile_match_file')){
    //   this.form.get('job_profile_match_file')?.updateValueAndValidity();
    // }
    
  }

}
